import React, { useRef } from 'react';
import {
    Box,
    Card,
    CardMedia,
    Grid,
    IconButton,
    Typography,
    Button,
    Tooltip,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import DeleteModal from '../../components/reusableComponents/DeleteModal';
import { getDateAsPerFormat } from '../../_helpers/reusablefunctions/dateSetter';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

function DemoCard({ cardData, handleDeleteItem, onEdit }) {
    const ref = useRef();

    const cardStyle = {
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0px 3px 6px rgba(0,0,0,0.1)',
        borderRadius: '10px',
        padding: '1.2rem',
        height: '100%',
        transition: 'transform 0.2s, box-shadow 0.2s',
        '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0px 5px 12px rgba(0,0,0,0.15)',
        },
    };

    const posterUrl = cardData.demoPoster_url || '';
    const genre = cardData?.genre?.genre || 'N/A';
    const language = cardData?.language?.language || 'N/A';
    const mood = cardData?.mood?.mood || 'N/A';
    const history = useHistory();

    const uploadDate = cardData?.created
        ? getDateAsPerFormat(cardData.created, 'DD Mon, YYYY')
        : 'N/A';

    const handleOpenDemo = () => {
        if (cardData.demo_link) {
            window.open(cardData.demo_link, '_blank', 'noopener,noreferrer');
        }
    };

    const handleCreateCampaign = () => {
        history.push(`/campaign/create`);
    }

    return (
        <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={4}
            xl={4}
            sx={{
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Card variant="outlined" sx={cardStyle}>
                {/* Top Section: Image and Delete Button */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                    <CardMedia
                        component="img"
                        image={posterUrl}
                        alt={cardData.audio_name}
                        sx={{
                            width: 64,
                            height: 64,
                            borderRadius: '50%',
                            objectFit: 'cover',
                            flexShrink: 0,
                        }}
                    />
                     <Box sx={{ display: 'flex', gap: 1 }}>
                    <IconButton
                        size="small"
                        title="Edit"
                        onClick={() => onEdit && onEdit(cardData)}
                        sx={{
                            color: '#666',
                            '&:hover': {
                                color: '#1976d2',
                            },
                        }}
                    >
                        <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                        size="small"
                        title="Delete"
                        onClick={() => ref.current?.handleOpen()}
                        sx={{
                            color: '#666',
                            '&:hover': {
                                color: '#d32f2f',
                            },
                        }}
                    >
                        <DeleteIcon fontSize="small" />
                    </IconButton></Box>
                </Box>

                {/* Content Section - grows to fill space */}
                <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                    {/* Title */}
                    {/* <Tooltip title={cardData.audio_name} arrow placement="top"> */}
                    <Typography
                        sx={{
                            fontSize: '1.1rem',
                            fontWeight: 600,
                            mb: 1,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            cursor: 'default',
                            color: '#212529',
                        }}
                    >
                        {cardData.audio_name}
                    </Typography>
                    {/* </Tooltip> */}

                    {/* DESCRIPTION - 2 lines with tooltip */}
                    <Tooltip
                        title={cardData.description || 'No description'}
                        arrow
                        placement="left"
                    >
                        <span style={{ display: 'inline-block', maxWidth: '100%' }}>
                            <Typography
                                sx={{
                                    fontSize: '0.875rem',
                                    color: '#6c757d',
                                    mb: 2,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: 'vertical',
                                    lineHeight: 1.4,
                                    // maxHeight: '2.8rem',
                                    cursor: 'default',
                                }}
                            >
                                {cardData.description || 'No description'}
                            </Typography>
                        </span>
                    </Tooltip>

                    {/* Chips: genre / mood */}
                    <Box
                        sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 1,
                            mb: 1.5,
                        }}
                    >
                        <Box
                            sx={{
                                px: 1.5,
                                py: 0.5,
                                borderRadius: '6px',
                                backgroundColor: '#f5f5f5',
                                fontSize: '0.875rem',
                                color: '#495057',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            Genre: {genre}
                        </Box>

                        <Box
                            sx={{
                                px: 1.5,
                                py: 0.5,
                                borderRadius: '6px',
                                backgroundColor: '#f5f5f5',
                                fontSize: '0.875rem',
                                color: '#495057',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            Mood: {mood}
                        </Box>
                    </Box>

                    {/* Language chip */}
                    <Box
                        sx={{
                            display: 'flex',
                            mb: 1.5,
                        }}
                    >
                        <Box
                            sx={{
                                px: 1.5,
                                py: 0.5,
                                borderRadius: '6px',
                                backgroundColor: '#f5f5f5',
                                fontSize: '0.875rem',
                                color: '#495057',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            Lang: {language}
                        </Box>
                    </Box>

                    {/* Bottom section - pushed to bottom with mt: auto */}
                    <Box sx={{ mt: 'auto', display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                        {/* DEMO LINK BUTTON */}
                       <Box sx={{display:'flex' , justifyContent:'space-between' , alignItems:'center'}}>   
                         {cardData.demo_link && (
                            <Button
                                size="small"
                                variant="text"
                                sx={{
                                    fontSize: '0.875rem',
                                    fontWeight: 500,
                                    paddingLeft: 0,
                                    justifyContent: 'flex-start',
                                    minWidth: 'auto',
                                    textTransform: 'uppercase',
                                    color: '#dc3545',
                                    '&:hover': {
                                        backgroundColor: 'transparent',
                                        color: '#bb2d3b',
                                    }
                                }}
                                onClick={handleOpenDemo}
                            >
                                VIEW DEMO LINK
                            </Button>
                        )}
                        {/* <Button 
                            size="small"
                            variant="text"
                            sx={{
                                fontSize: '0.875rem',
                                fontWeight: 500,
                                paddingLeft: 0,
                                justifyContent: 'flex-start',
                                minWidth: 'auto',
                                textTransform: 'uppercase',
                                color: '#dc3545',
                                '&:hover': {
                                    backgroundColor: 'transparent',
                                    color: '#bb2d3b',
                                }
                            }}
                            onClick={handleCreateCampaign}
                        >
                            CREATE CAMPAIGN
                        </Button> */}
                       </Box>

                        <Typography
                            sx={{
                                fontSize: '0.8rem',
                                color: '#6c757d',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            Upload: {uploadDate}
                        </Typography>
                    </Box>
                </Box>
            </Card>

            <DeleteModal
                cardId={cardData?.id}
                deleteHandler={handleDeleteItem}
                ref={ref}
            />
        </Grid>
    );
}

export default DemoCard;